import React from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Capacitor } from '@capacitor/core';
import { useConsent } from '../contexts/ConsentContext';
import './CookieConsentBanner.css';

export const CookieConsentBanner: React.FC<{ hidden?: boolean }> = ({ hidden = false }) => {
  const { t } = useTranslation('common');
  const { isDecided, grantConsent, denyConsent } = useConsent();

  // App Store 5.1.2(i) — pas de prompt cookies sur iOS natif (tracking désactivé).
  const isNativeIOS = Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
  if (hidden || isNativeIOS || isDecided) return null;

  return createPortal(
    <div
      className='cookie-banner'
      role='dialog'
      aria-live='polite'
      aria-label={t('cookieBanner.aria')}    >
      <div className='cookie-banner__bg' />
      <div className='cookie-banner__inner'>
        <div className='cookie-banner__text'>
          {t('cookieBanner.textBefore')}{' '}
          <Link to='/privacy-policy'>{t('cookieBanner.privacyLink')}</Link>
          {t('cookieBanner.textAfter')}
        </div>
        <div className='cookie-banner__buttons'>
          <button type='button' className='cookie-btn cookie-btn--decline' onClick={denyConsent}>
            {t('cookieBanner.decline')}
          </button>
          <button type='button' className='cookie-btn cookie-btn--accept' onClick={grantConsent}>
            {t('cookieBanner.accept')}          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CookieConsentBanner;
